export enum FormStatusEnum {
  Valid = 'VALID',
  Invalid = 'INVALID',
  Disabled = 'DISABLED',
  Pending = 'PENDING',
}
